import {postUnreadAnnouncement} from '../../providers/support/support';

const pushKey = '@pezPush';

function normalizePushMessages(value) {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(
    (message) =>
      message && typeof message === 'object' && !Array.isArray(message),
  );
}

function readPushMessages() {
  try {
    const value = localStorage.getItem(pushKey);
    return value ? normalizePushMessages(JSON.parse(value)) : [];
  } catch (error) {
    return [];
  }
}

function storePushMessages(value, updater) {
  const messages = normalizePushMessages(value);
  updater({savedPushMessage: messages});

  try {
    localStorage.setItem(pushKey, JSON.stringify(messages));
  } catch (error) {
    // The in-memory state is still usable when storage is unavailable.
  }

  return messages;
}

export function savaPushMessage(value, updater) {
  storePushMessages(value, updater);
}

export function getPushMessage(updater) {
  storePushMessages(readPushMessages(), updater);
}

export function deletePushMessageById(id, updater) {
  const messages = readPushMessages();
  const index = messages.findIndex((item) => item.id === id);
  if (index !== -1) {
    const updatedMessages = messages.filter((item) => item.id !== id);
    storePushMessages(updatedMessages, updater);
  }
}

export function markAsRead(updater) {
  const messages = readPushMessages();
  const unreadMessages = messages.filter((item) => !item.status);

  if (unreadMessages.length) {
    const updatedMessages = messages.map((item) => ({...item, status: true}));
    storePushMessages(updatedMessages, updater);
    postUnreadAnnouncement(
      unreadMessages.map((item) => item.id).filter((id) => id != null),
    );
  }
}

export function getUnreadCount(array) {
  return normalizePushMessages(array).filter((item) => !item.status).length;
}
